import { Directive, OnInit, Renderer2, Input, ElementRef, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

/**
 * Resize Column Directive
 * Allows for resizing table column's widths
 */
@Directive({
	selector: '[resizeColumn]'
})
export class ResizeColumnDirective implements OnInit, OnChanges {
	@Input('resizeColumn') resizable: boolean;
	@Input('columnWidth') columnWidth: any;
	@Output() resized: EventEmitter<any> = new EventEmitter();

	@Input() index: number;

	private startX: number;

	private startWidth: number;

	private column: HTMLElement;

	private table: HTMLElement;

	private pressed: boolean;

	constructor(private renderer: Renderer2, private el: ElementRef) {
		this.column = this.el.nativeElement;
	}

	getWidth(column: any) {
		let val = column.extra?.width;

		if (this.columnWidth.settings.columnWidths) {
			for (let item of this.columnWidth.settings.columnWidths) {
				if (item.name === column.name) val = item.width;
			}
		}

		return val ? val + 'px' : '150px';
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.columnWidth && changes.columnWidth) {
			const width = this.getWidth(this.columnWidth.column);
			this.renderer.setStyle(this.column, 'width', `${width}`);
		}
	}

	ngOnInit() {
		if (this.resizable) {
			const row = this.renderer.parentNode(this.column);
			const thead = this.renderer.parentNode(row);
			this.table = this.renderer.parentNode(thead);

			const resizer = this.renderer.createElement('span');
			this.renderer.addClass(resizer, 'resize-holder');
			this.renderer.appendChild(this.column, resizer);
			this.renderer.listen(resizer, 'mousedown', this.onMouseDown);
			this.renderer.listen(this.table, 'mousemove', this.onMouseMove);
			this.renderer.listen('document', 'mouseup', this.onMouseUp);
		}
	}

	onMouseDown = (event: MouseEvent) => {
		this.pressed = true;
		this.startX = event.pageX;
		this.startWidth = this.column.offsetWidth;
	};

	onMouseMove = (event: MouseEvent) => {
		const offset = 35;
		if (this.pressed && event.buttons) {
			this.renderer.addClass(this.table, 'resizing');

			// Calculate width of column
			const width = this.startWidth + (event.pageX - this.startX - offset);

			const tableCells = Array.from(this.table.querySelectorAll('.mat-row')).map((row: any) =>
				row.querySelectorAll('.mat-cell').item(this.index)
			);

			// Set table header width
			this.renderer.setStyle(this.column, 'width', `${width}px`);

			// Set table cells width
			for (const cell of tableCells) {
				if (cell) {
					this.renderer.setStyle(cell, 'width', `${width}px`);
				}
			}
		}
	};

	onMouseUp = (event: MouseEvent) => {
		if (this.pressed) {
			this.pressed = false;
			this.renderer.removeClass(this.table, 'resizing');

			this.resized.emit({
				column: this.column,
				width: this.column.offsetWidth
			});
		}
	};
}
